import React, { Component } from 'react';
import { Application } from '../../core/app';
class AppFooter extends Component {
  /**
   * Render the component view.
   */
  render() {
    return (
      <footer className="app-footer">
        <div className="app-footer__content">
          <p className="app-footer__copyright">
            {this.props.copyrightText}
          </p>
          <ul className="app-footer__legal-content">
            <li className="app-footer__legal-content-item app-footer__legal-content-terms">
              <span className="app-footer__legal-content-link standard-link" onClick={this.props.onShowTerms}>
                Terms & Conditions
              </span>
            </li>
            <li className="app-footer__legal-content-item app-footer__legal-content-privacy">
              <a className="app-footer__legal-content-link gothambook-font" 
                target="_blank" 
                rel="noopener noreferrer" 
                href={Application.getPrivacyPolicy()}>
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </footer>
    );
  }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/application/app-footer.js